import { render, staticRenderFns } from "./NormalSearchNav322.vue?vue&type=template&id=5470dc05&scoped=true&"
import script from "./NormalSearchNav322.vue?vue&type=script&lang=js&"
export * from "./NormalSearchNav322.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5470dc05",
  null
  
)

export default component.exports